<ix-oauth-provider-authentication
  [oauthUrl]="provider.credentials_oauth"
  (authenticated)="onOauthAuthenticated($event)"
></ix-oauth-provider-authentication>

<ix-fieldset [title]="'Authentication' | translate" [formGroup]="form">
  <ix-input
    formControlName="token"
    type="password"
    [label]="'Access Token' | translate"
    [required]="true"
    [tooltip]="helptext.token_pcloud.tooltip | translate"
  ></ix-input>

  <ix-input
    formControlName="hostname"
    [label]="'Hostname' | translate"
    [tooltip]="helptext.hostname_pcloud.tooltip | translate"
  ></ix-input>
</ix-fieldset>
